"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertTimezone = convertTimezone;
function convertTimezone(date) {
  const _date = date instanceof Date ? date : new Date(date);
  return _date.getTime() + _date.getTimezoneOffset() * 60000;
}